import React, { useState } from 'react';
import { Table, Select, Col, Row, Pagination, Input, Tooltip } from 'antd';
import addIcon from '../../assets/images/icons/add.svg';
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import editIcon from '../../assets/images/icons/edit.svg';
import TableDocIcon from '../../assets/newlayout/table_doc_icon.svg';
import checkIcon from '../../assets/images/icons/check.svg';
import crossIcon from '../../assets/images/icons/cross.svg';

const baseMediaPlans = [
    {
        id: 1,
        status: 'active',
        name: 'Daily Adkernel File Analysis',
        schedule: '7 Days',
        lastUpdatedAt: 'Mar 20, 2026 | 20:03:23 PST',
        createdBy: 'harshil@xapads.com',
        createdAt: 'Mar 20, 2026 | 20:03:23 PST',
    },
    {
        id: 2,
        status: 'inactive',
        name: 'Weekly Revenue Report',
        schedule: '15 Days',
        lastUpdatedAt: 'Mar 20, 2026 | 20:03:23 PST',
        createdBy: 'harshil@xapads.com',
        createdAt: 'Mar 20, 2026 | 20:03:23 PST',
    },
    {
        id: 3,
        status: 'archived',
        name: 'Weekly Revenue Report',
        schedule: '-',
        lastUpdatedAt: 'Mar 20, 2026 | 20:03:23 PST',
        createdBy: 'harshil@xapads.com',
        createdAt: 'Mar 20, 2026 | 20:03:23 PST',
    },
];

const mediaPlanRows = Array.from({ length: 234 }, (_, index) => {
    const baseRow = baseMediaPlans[index % baseMediaPlans.length];

    return {
        ...baseRow,
        id: index + 1,
        key: index + 1,
        name: index < 3 ? baseRow.name : `${baseRow.name} ${index + 1}`,
    };
});

const searchIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 14.0001L11.1 11.1001" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Archived', value: 'archived' },
];

const statusClassMap = {
    active: 'approved',
    inactive: 'declined',
    archived: 'archived',
};

const scheduleOptions = [
    { label: '7 Days', value: '7 Days' },
    { label: '15 Days', value: '15 Days' },
    { label: '30 Days', value: '30 Days' },
];

const NewMediaPlannerTable = () => {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({
        current: 1,
        pageSize: 20,
    });
    const [tableData, setTableData] = useState(mediaPlanRows);
    const [editingSchedule, setEditingSchedule] = useState(null);

    const filteredData = tableData.filter((item) => {
        const searchValue = search.trim().toLowerCase();

        if (!searchValue) {
            return true;
        }

        return (
            item.name.toLowerCase().includes(searchValue) ||
            item.status.toLowerCase().includes(searchValue) ||
            item.createdBy.toLowerCase().includes(searchValue)
        );
    });

    const startIndex = (page.current - 1) * page.pageSize;
    const endIndex = startIndex + page.pageSize;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    const handleStatusChange = (key, value) => {
        setTableData((prevData) => prevData.map((item) => (
            item.key === key ? { ...item, status: value } : item
        )));
    };

    const handleScheduleEditStart = (record) => {
        setEditingSchedule({
            key: record.key,
            value: record.schedule,
        });
    };

    const handleScheduleChange = (value) => {
        setEditingSchedule((prevState) => prevState ? { ...prevState, value } : prevState);
    };

    const handleScheduleSave = () => {
        if (!editingSchedule) {
            return;
        }

        setTableData((prevData) => prevData.map((item) => (
            item.key === editingSchedule.key ? { ...item, schedule: editingSchedule.value } : item
        )));
        setEditingSchedule(null);
    };

    const handleScheduleCancel = () => {
        setEditingSchedule(null);
    };

    const handlePageChange = (currentPage) => {
        setPage((prevPage) => ({
            ...prevPage,
            current: currentPage,
        }));
    };

    const handlePageSizeChange = (pageSize) => {
        setPage({
            current: 1,
            pageSize,
        });
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <span><img src={prevIcon} alt='USP' /></span>;
        }

        if (type === 'next') {
            return <span><img src={nextIcon} alt='USP' /></span>;
        }

        return originalElement;
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 64,
            render: (_, record) => (
                <div className='btn_group align-items-center'>
                    <Tooltip title="Edit">
                        <button className='download_icon download_icon_d2' type='button'>
                            <img src={editIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    <Tooltip title="View">
                        <button className='download_icon download_icon_d2' type='button'>
                            <img src={TableDocIcon} alt='USP' />
                        </button>
                    </Tooltip>
                </div>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 96,
            render: (text, record) => {
                if (text === 'inactive') {
                    return (
                        <Tooltip title="Inactive media plan">
                            <div className='new_mp_table_inactive_status_tag'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_14252_29315)">
                                        <path d="M6.99935 12.8334C10.221 12.8334 12.8327 10.2217 12.8327 7.00008C12.8327 3.77842 10.221 1.16675 6.99935 1.16675C3.77769 1.16675 1.16602 3.77842 1.16602 7.00008C1.16602 10.2217 3.77769 12.8334 6.99935 12.8334Z" stroke="#020617" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7 4.66675V7.00008" stroke="#020617" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7 9.33325H7.00583" stroke="#020617" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_14252_29315">
                                            <rect width="14" height="14" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                Inactive
                            </div>
                        </Tooltip>
                    );
                }

                return (
                    <div className='w_100 position-relative'>
                        <Select
                            showSearch={false}
                            className={`form_select badge_content--${statusClassMap[text] || 'approved'}`}
                            dropdownStyle={{
                                width: '12rem',
                            }}
                            value={text}
                            options={statusOptions}
                            onChange={(value) => handleStatusChange(record.key, value)}
                        />
                    </div>
                );
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 800,
            render: (text) => <div className='color_900'>{text}</div>,
        },
        {
            title: 'Schedule',
            dataIndex: 'schedule',
            key: 'schedule',
            width: 215,
            render: (text, record) => {
                const isEditing = editingSchedule?.key === record.key;

                if (text === '-') {
                    return <div className='color_900'>-</div>;
                }

                if (isEditing) {
                    return (
                        <div className='d-flex align-items-center justify-content-between gap_8'>
                            <Select
                                showSearch={false}
                                className='form_select basic sm no_search'
                                style={{ width: '11rem' }}
                                value={editingSchedule.value}
                                options={scheduleOptions}
                                suffixIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 6L8 10L12 6" stroke="#475569" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                                onChange={handleScheduleChange}
                            />
                            <div className='btn_group d-flex align-items-center' style={{ gap: '0.8rem' }}>
                                <Tooltip title="Save">
                                    <button
                                        className='btn_outline_success btn --diff_clr_of_approved_box'
                                        style={{ width: '2.8rem', height: '2.8rem' }}
                                        type='button'
                                        onClick={handleScheduleSave}
                                    >
                                        <img src={checkIcon} alt='USP' />
                                    </button>
                                </Tooltip>
                                <Tooltip title="Cancel">
                                    <button
                                        className='btn_outline_danger btn --diff_clr_of_reject_box'
                                        type='button'
                                        onClick={handleScheduleCancel}
                                    >
                                        <img src={crossIcon} style={{ filter: 'none' }} alt='USP' />
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    );
                }

                return (
                    <div className='d-flex align-items-center justify-content-between' style={{ minWidth: '14rem', gap: '1.2rem' }}>
                        <div className='color_900'>{text}</div>
                        <Tooltip title="Edit Schedule">
                            <button
                                className='download_icon download_icon_d2'
                                type='button'
                                onClick={() => handleScheduleEditStart(record)}
                            >
                                <img src={editIcon} alt='USP' />
                            </button>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            title: 'Last Updated At',
            dataIndex: 'lastUpdatedAt',
            key: 'lastUpdatedAt',
            width: 180,
            render: (text) => <div className='text_light_css'>{text}</div>,
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 190,
            render: (_, record) => (
                <div>
                    <div className='color_900'>{record.createdBy}</div>
                    <div className='text_light_css'>{record.createdAt}</div>
                </div>
            ),
        },
    ];


    return (
        <div className="container_box--wrapper pt_header --wrapper-v2">
            <div className="title_intro">
                <h1 className="heading">
                    Media Planner
                </h1>
            </div>
            <div className={paginatedData.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                <div className="table_area_div">

                    <div className='searchbar_with_btns'>
                        <div className="d_flex align-items-center justify_content_between w_100">
                            <div>
                                <Input
                                    type='text'
                                    className='form_control basic'
                                    placeholder="Search"
                                    prefix={searchIcon}
                                    value={search}
                                    onChange={(event) => {
                                        setSearch(event.target.value);
                                        setPage((prevPage) => ({
                                            ...prevPage,
                                            current: 1,
                                        }));
                                    }}
                                    style={{ width: '22rem' }}
                                />
                            </div>

                            <div className='btn_group'>
                                <button className='btn btn_primary w_fit_content md' type='button'>
                                    <span><img src={addIcon} alt='USP' /> Create New Media Plan</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                        <Table
                            columns={columns}
                            dataSource={paginatedData}
                            pagination={false}
                            rowKey="key"
                            scroll={{ x: paginatedData.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 31.2rem' }}
                        />

                        {filteredData.length > 0 &&
                            <Row className="custom_pagination--container">
                                <Col span={6}>
                                    <div className="form_content_block--group mb_0">
                                        <Select
                                            className='form_select basic sm no_search'
                                            value={page.pageSize}
                                            onChange={handlePageSizeChange}
                                            style={{ width: 80 }}
                                            showSearch={false}
                                            options={[
                                                { value: 10, label: 10 },
                                                { value: 20, label: 20 },
                                                { value: 50, label: 50 },
                                                { value: 100, label: 100 },
                                            ]}
                                        />
                                        <label className='custom_pagination--label'>
                                            items per page
                                        </label>
                                    </div>
                                </Col>
                                <Col span={6}>
                                    <span className="custom_pagination--total-text">
                                        {`${startIndex + 1}-${Math.min(page.current * page.pageSize, filteredData.length)} of ${filteredData.length} items`}
                                    </span>
                                </Col>
                                <Col span={6}>
                                    <Pagination
                                        current={page.current}
                                        pageSize={page.pageSize}
                                        total={filteredData.length}
                                        onChange={handlePageChange}
                                        showSizeChanger={false}
                                        itemRender={itemRender}
                                        className="custom_pagination"
                                    />
                                </Col>
                            </Row>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewMediaPlannerTable;
